import { render } from "./DayZeroMail.vue?vue&type=template&id=57aea1e6&scoped=true"
import script from "./DayZeroMail.vue?vue&type=script&lang=js"
export * from "./DayZeroMail.vue?vue&type=script&lang=js"

import "./DayZeroMail.vue?vue&type=style&index=0&id=57aea1e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57aea1e6"]])

export default __exports__